import { render, staticRenderFns } from "./AppIframe.vue?vue&type=template&id=6ec7a8e4&"
import script from "./AppIframe.vue?vue&type=script&lang=js&"
export * from "./AppIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports